import { useFormContext, useFormField } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Скрытое поле для записи и хранения значений извне.
 */
export var HiddenField = function HiddenField(props) {
  var name = props.name,
    required = props.required;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting;
  var _useFormField = useFormField({
      name: name
    }),
    _useFormField$field = _useFormField.field,
    _useFormField$field$v = _useFormField$field.value,
    value = _useFormField$field$v === void 0 ? '' : _useFormField$field$v,
    onBlur = _useFormField$field.onBlur,
    onChange = _useFormField$field.onChange;
  return /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: name,
    value: value,
    disabled: isSubmitting,
    maxLength: 100,
    onChange: onChange,
    onBlur: onBlur,
    required: required
  });
};
HiddenField.displayName = 'HiddenField';